import { ErrorMessage } from "@hookform/error-message";
import { useEffect, useState } from "react";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import { NumericFormat, numericFormatter } from "react-number-format";
import {
  Col,
  RSelect,
  Row,
} from "../../../components/Component";
import { GET } from "../../../helper/api";
import { CURRENCY_CODE_OPTIONS } from "../../../utils/Utils";
import moment from "moment";
import { formatBankAccountWithBalanceOptions } from "../../../helper/bank-account";



const UpsertCustomerMoneyFlowComponent = ({
  type,
  disabledForm,
}) => {

  const [bankAccountOptions, setBankAccountOptions] = useState([]);
  const [customers, setCustomers] = useState([]);

  const { errors, register, control, setValue, watch } = useFormContext();

  useEffect(() => {
    GET("/bank-account/find-all-with-balance", {}, true).then((resp) => {
      const { data } = resp;
      if (data) {
        setBankAccountOptions(formatBankAccountWithBalanceOptions(data));
      }
    });

    GET(`/customer/find-all-with-balance`, {}, true).then((resp) => {
      const { data } = resp;
      if (data) {
        setCustomers(data.map((cus) => ({
          label: `${cus.name} (${numericFormatter(`${cus.lastDebt || 0}`, {
            thousandsGroupStyle: "thousand",
            thousandSeparator: ",",
            suffix: " đ",
            decimalScale: 2
          })})`,
          value: cus.id,
          data: cus,
        })))
      }
    });
  }, []);

  const currency = useWatch({
    control,
    name: "currency",
  });

  const exchangeRate = useWatch({
    control,
    name: "exchangeRate",
  });

  const amountUSD = useWatch({
    control,
    name: "amountUSD",
  });

  useEffect(() => {
    if (currency === 'VND') {
      setValue('amountUSD', '');
      setValue('exchangeRate', '');
    }

    if (currency === 'USD') {
      setValue('amount', (amountUSD && exchangeRate) ? Math.round(amountUSD * exchangeRate) : '')
    }
  }, [currency, amountUSD, exchangeRate])

  return (
    <div className="position-relative">
      {disabledForm ? <div className="form-overlay"></div> : <></>}
      <Row className="g-2">
        <Col size="6">
          <div className="form-group">
            <label className="form-label" >
              Ngày <span className="text-danger">*</span>
            </label>
            <div className="form-control-wrap">
              <input
                className="form-control"
                type="date"
                name="date"
                max={moment().format("YYYY-MM-DD")}
                ref={register({
                  required: "Vui lòng nhập thông tin",
                })}
              />
              <ErrorMessage
                errors={errors}
                name="date"
                render={({ message }) => (
                  <span className="invalid">{message}</span>
                )}
              />
            </div>
          </div>
        </Col>
        <Col size="6">
          <div className="form-group">
            <label className="form-label" >
              {type === 'OUT' ? 'Nhà cung cấp' : 'Khách hàng'} <span className="text-danger">*</span>
            </label>
            <div className="form-control-wrap">
              <Controller
                control={control}
                name="customerId"
                rules={{
                  required: "Vui lòng nhập thông tin",
                }}
                render={({ onChange, name, value, ref }) => (
                  <RSelect
                    name={name}
                    inputRef={ref}
                    options={customers}
                    value={
                      customers.find(
                        (c) => c.value == value
                      ) || ""
                    }
                    onChange={(val) => onChange(val?.value)}
                  />
                )}
              />
              <ErrorMessage
                errors={errors}
                name="customerId"
                render={({ message }) => (
                  <span className="invalid">{message}</span>
                )}
              />
            </div>
          </div>
        </Col>

        <Col size="6">
          <div className="form-group">
            <label className="form-label" >
              Quỹ tài khoản <span className="text-danger">*</span>
            </label>
            <div className="form-control-wrap">
              <Controller
                control={control}
                name="bankAccountId"
                rules={{
                  required: "Vui lòng nhập thông tin",
                }}
                render={({ onChange, name, value, ref }) => (
                  <RSelect
                    name={name}
                    inputRef={ref}
                    options={bankAccountOptions}
                    value={
                      bankAccountOptions.find(
                        (c) => c.value == value
                      ) || ""
                    }
                    onChange={(val) => onChange(val?.value)}
                  />
                )}
              />
              <ErrorMessage
                errors={errors}
                name="bankAccountId"
                render={({ message }) => (
                  <span className="invalid">{message}</span>
                )}
              />
            </div>
          </div>
        </Col>


        <Col md="6">
          <div className="form-group">
            <label className="form-label" >
              Tiền tệ
            </label>
            <div className="form-control-wrap">
              <Controller
                control={control}
                name="currency"
                render={({ onChange, value, name, ref }) => (
                  <RSelect ref={ref} name={name} options={CURRENCY_CODE_OPTIONS} value={CURRENCY_CODE_OPTIONS.find((c) => c.value === value)} onChange={(val) => onChange(val.value)} />
                )}
              />
            </div>
          </div>
        </Col>

        {currency === "USD" ? (
          <>
            <Col md="6">
              <div className="form-group">
                <label className="form-label" >
                  {type === 'IN' ? 'Tiền thu ' : 'Tiền chi'}($)<span className="text-danger">*</span>
                </label>
                <div className="form-control-wrap">
                  <Controller
                    control={control}
                    name="amountUSD"
                    rules={{ required: "Vui lòng nhập thông tin" }}
                    render={({ onChange, value, ref }) => (
                      <NumericFormat
                        className="form-control"
                        getInputRef={ref}
                        type="text"
                        value={value}
                        thousandsGroupStyle="thousand"
                        thousandSeparator=","
                        decimalScale={4}
                        onValueChange={(val) => onChange(val.floatValue)}
                      />
                    )}
                  />
                  <ErrorMessage errors={errors} name="amountUSD" render={({ message }) => <span className="invalid">{message}</span>} />
                </div>
              </div>
            </Col>

            <Col md="6">
              <div className="form-group">
                <label className="form-label" >
                  Tỉ giá<span className="text-danger">*</span>
                </label>
                <div className="form-control-wrap">
                  <Controller
                    control={control}
                    name="exchangeRate"
                    rules={{ required: "Vui lòng nhập thông tin" }}
                    render={({ onChange, value, ref }) => (
                      <NumericFormat
                        className="form-control"
                        getInputRef={ref}
                        type="text"
                        value={value}
                        thousandsGroupStyle="thousand"
                        thousandSeparator=","
                        decimalScale={2}
                        onValueChange={(val) => onChange(val.floatValue)}
                      />
                    )}
                  />
                  <ErrorMessage errors={errors} name="exchangeRate" render={({ message }) => <span className="invalid">{message}</span>} />
                </div>
              </div>
            </Col>
          </>
        ) : (
          <></>
        )}

        <Col size="6">
          <div className="form-group">
            <label className="form-label" >
              {type === 'IN' ? 'Tiền thu từ ' : 'Tiền chi cho'} KH/NCC(đ) <span className="text-danger">*</span>
            </label>
            <div className="form-control-wrap">
              <Controller
                control={control}
                name="amount"
                rules={{
                  required: "Vui lòng nhập thông tin",
                }}
                render={({ onChange, value, ref }) => (
                  <NumericFormat
                    disabled={currency !== 'VND'}
                    className="form-control"
                    inputRef={ref}
                    type="text"
                    value={value}
                    thousandsGroupStyle="thousand"
                    thousandSeparator=","
                    decimalScale={2}
                    onValueChange={(val) =>
                      onChange(val.floatValue)
                    }
                  />
                )}
              />
              <ErrorMessage
                errors={errors}
                name="amount"
                render={({ message }) => (
                  <span className="invalid">{message}</span>
                )}
              />
            </div>
          </div>
        </Col>

        <Col size="6">
          <div className="form-group">
            <label className="form-label" >
              Người nhận
            </label>
            <div className="form-control-wrap">
              <input
                className="form-control"
                type="text"
                name="receiver"
                ref={register()}
              />

              <ErrorMessage
                errors={errors}
                name="receiver"
                render={({ message }) => (
                  <span className="invalid">{message}</span>
                )}
              />
            </div>
          </div>
        </Col>

        <Col size="6">
          <div className="form-group">
            <label className="form-label" >
              Nội dung
            </label>
            <div className="form-control-wrap">
              <input
                className="form-control"
                type="text"
                name="content"
                ref={register()}
              />

              <ErrorMessage
                errors={errors}
                name="content"
                render={({ message }) => (
                  <span className="invalid">{message}</span>
                )}
              />
            </div>
          </div>
        </Col>

        <Col size="6">
          <div className="form-group">
            <label className="form-label" >
              Ghi chú
            </label>
            <div className="form-control-wrap">
              <input
                type="text"
                className="form-control"
                name="note"
                ref={register()}
              />

              <ErrorMessage
                errors={errors}
                name="note"
                render={({ message }) => (
                  <span className="invalid">{message}</span>
                )}
              />
            </div>
          </div>
        </Col>

        <Col md="6" className={'d-none'}>
          <div className="form-group">
            <label className="form-label" >
              Giao dich NH
            </label>
            <div className="form-control-wrap">
              <input
                type="text"
                className="form-control"
                name="hookTransactionHistoryId"
                ref={register()}
              />
            </div>
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default UpsertCustomerMoneyFlowComponent;